<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-secondary">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">VISAD</a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
              aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item" v-if="currentPath">
            <router-link class="nav-link" to="/">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/privacy_policy">Informativa privacy</router-link>
          </li>
        </ul>
        <button class="btn btn-danger ms-auto" id="btn-logout" v-if="isLoggedInFlag && currentPath" @click="logout">Logout</button>
      </div>
    </div>
  </nav>
</template>

<script>
import {auth} from '../utils/js/firebase';
import {signOut, onAuthStateChanged} from 'firebase/auth';

export default {
  name: 'Navbar',
  data() {
    return {
      isLoggedInFlag: false,
      isAdminFlag: false,
    }
  },
  methods: {
    logout() {
      signOut(auth).then(() => {
        localStorage.removeItem('user-info');
        this.$router.push('/auth');
      }).catch((error) => {
        // An error happened.
        console.log(error);
      });
    },
    getUserInfoFromSession() {
      return new Promise((resolve, reject) => {
        try {
          const userInfoString = localStorage.getItem('user-info');
          if (userInfoString) {
            resolve(JSON.parse(userInfoString)); // Convert and resolve with the dictionary
          } else {
            resolve(null); // or reject("User info not found") if you want to handle it as an error
          }
        } catch (error) {
          reject(error); // Reject the promise if there's an error parsing the JSON
        }
      });
    }

  },
  computed: {
    currentPath() {
      return (this.$route.path !== '/auth' && this.$route.path !== '/patients');
    }
  },
  mounted() {
    onAuthStateChanged(auth, async (user) => {
      this.isLoggedInFlag = !!user;
    })
  }

}
;
</script>

<style scoped>
nav {
  padding-right: 30px;
  padding-left: 30px;
}

#btn-logout {
  text-align: right;
}
</style>